// src/admin/components/AnalyticsCard.jsx

import { useTheme } from "../../context/ThemeContext";

export default function AnalyticsCard({
  title,
  value,
  subtitle,
}) {

  const { isDark } = useTheme();

  return (
    <div
      className={`
        rounded-3xl
        p-6
        border
        transition-all
        ${
          isDark
            ? "bg-white/5 border-white/10"
            : "bg-white border-gray-200"
        }
      `}
    >
      <p
        className={
          isDark
            ? "text-gray-400"
            : "text-gray-500"
        }
      >
        {title}
      </p>

      <h3 className="mt-2 text-4xl font-bold">
        {value}
      </h3>

      {subtitle && (
        <p
          className="
            mt-2
            text-sm
            text-blue-500
          "
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}